import React from "react";
import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

export const TaglineMarquee = () => {
  const items = ["Great Drinks", "Great Times", "Great People", "Karaoke Nights", "Live Music"];
  return (
    <div
      data-testid="tagline-marquee"
      className="bg-[#F5A623] text-black py-5 border-y-2 border-black overflow-hidden"
    >
      <Marquee speed={55} gradient={false}>
        {Array.from({ length: 4 }).flatMap((_, batch) =>
          items.map((t, i) => (
            <div
              key={`${batch}-${i}`}
              className="flex items-center gap-6 mx-6 font-display text-2xl sm:text-3xl uppercase tracking-wider"
            >
              <span>{t}</span>
              <Star size={20} fill="currentColor" />
            </div>
          ))
        )}
      </Marquee>
    </div>
  );
};
